import { Component, Input, OnInit } from "@angular/core";
import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { PlayerModal } from "app/components";
import { PlayerDto, SubstitutionConditionDto, SubstitutionDto, TacticDto } from "app/models";
import { NotificationService, PlayerService } from "app/services";
import { CONSTANTS } from '../../../constants';

@Component({
    selector: 'edit-substitution-modal',
    templateUrl: './edit-substitution.modal.html',
    styleUrls: ['./edit-substitution.modal.scss'],
})
export class EditSubstitutionModal implements OnInit {
    @Input() substitution: SubstitutionDto;

    @Input() squad: PlayerDto[];
    @Input() reserve: PlayerDto[];

    @Input() currectTactic: TacticDto;
    
    minutesLookup: number[];
    scoresLookup: number[];
    marksLookup: number[];
    physicsLookup: number[];
    pitchPositions: string[];
    pitchPositionsLookup: number[];

    const;

    private squadDictionary: PlayerDto[];
    private reserveDictionary: PlayerDto[];

    constructor(public activeModal: NgbActiveModal, private playerService: PlayerService, private modalService: NgbModal) {
        this.const = CONSTANTS;
    }

    ngOnInit(): void {
        this.buildLookups();
        this.buildPlayerDictionaries();
    }

    getMinuteLabel() {
        if (!this.substitution.minute)
            return null;

        return this.substitution.minute.value;
    }

    selectMinute(val: number) {
        this.substitution.minute.value = val;
    }

    isMinuteSectionVisible(): boolean {
        if (!this.substitution.minute)
            return false;

        return true;
    }

    toggleMinuteSection() {
        if (this.substitution.minute)
            this.substitution.minute = null;
        else {
            this.substitution.minute = new SubstitutionConditionDto();
            this.substitution.minute.value = 0;
            this.substitution.minute.condition = CONSTANTS.substitutionConditions.more;
        }
    }

    isMinuteLessConditionSelected(): boolean {
        if (!this.substitution.minute)
            return false;
        
        return this.substitution.minute.condition === CONSTANTS.substitutionConditions.less;
    }

    isMinuteGreaterConditionSelected(): boolean {
        if (!this.substitution.minute)
            return false;
        
        return this.substitution.minute.condition === CONSTANTS.substitutionConditions.more;
    }

    changeMinuteCondition(val: number) {
        this.substitution.minute.condition = val;
    }

    getScoreLabel() {
        if (!this.substitution.score)
            return null;

        return this.substitution.score.value;
    }

    selectScore(val: number) {
        this.substitution.score.value = val;
    }

    isScoreSectionVisible(): boolean {
        if (!this.substitution.score)
            return false;

        return true;
    }

    toggleScoreSection() {
        if (this.substitution.score)
            this.substitution.score = null;
        else {
            this.substitution.score = new SubstitutionConditionDto();
            this.substitution.score.value = 0;
            this.substitution.score.condition = CONSTANTS.substitutionConditions.more;
        }
    }

    isScoreLessConditionSelected(): boolean {
        if (!this.substitution.score)
            return false;
        
        return this.substitution.score.condition === CONSTANTS.substitutionConditions.less;
    }

    isScoreGreaterConditionSelected(): boolean {
        if (!this.substitution.score)
            return false;
        
        return this.substitution.score.condition === CONSTANTS.substitutionConditions.more;
    }

    isScoreEqualConditionSelected(): boolean {
        if (!this.substitution.score)
            return false;
        
        return this.substitution.score.condition === CONSTANTS.substitutionConditions.equal;
    }

    changeScoreCondition(val: number) {
        this.substitution.score.condition = val;
    }


    getMarkLabel() {
        if (!this.substitution.mark)
            return null;

        return this.substitution.mark.value.toFixed(1);
    }

    selectMark(val: number) {
        this.substitution.mark.value = val;
    }

    isMarkSectionVisible(): boolean {
        if (!this.substitution.mark)
            return false;

        return true;
    }

    toggleMarkSection() {
        if (this.substitution.mark)
            this.substitution.mark = null;
        else {
            this.substitution.mark = new SubstitutionConditionDto();
            this.substitution.mark.value = 4.0;
            this.substitution.mark.condition = CONSTANTS.substitutionConditions.more;
        }
    }

    isMarkLessConditionSelected(): boolean {
        if (!this.substitution.mark)
            return false;
        
        return this.substitution.mark.condition === CONSTANTS.substitutionConditions.less;
    }

    isMarkGreaterConditionSelected(): boolean {
        if (!this.substitution.mark)
            return false;
        
        return this.substitution.mark.condition === CONSTANTS.substitutionConditions.more;
    }

    isMarkEqualConditionSelected(): boolean {
        if (!this.substitution.mark)
            return false;
        
        return this.substitution.mark.condition === CONSTANTS.substitutionConditions.equal;
    }

    changeMarkCondition(val: number) {
        this.substitution.mark.condition = val;
    }

    getPhysicLabel() {
        if (!this.substitution.physic)
            return null;

        return this.substitution.physic.value;
    }

    selectPhysic(val: number) {
        this.substitution.physic.value = val;
    }

    isPhysicSectionVisible(): boolean {
        if (!this.substitution.physic)
            return false;

        return true;
    }

    togglePhysicSection() {
        if (this.substitution.physic)
            this.substitution.physic = null;
        else {
            this.substitution.physic = new SubstitutionConditionDto();
            this.substitution.physic.value = 90;
            this.substitution.physic.condition = CONSTANTS.substitutionConditions.less;
        }
    }

    isYellowCardSectionVisible(): boolean {
        if (!this.substitution.isYellowCard)
            return false;

        return true;
    }

    toggleYellowCardSection() {
        if (this.substitution.isYellowCard) {
            this.substitution.isYellowCard = false;
        }
        else {
            this.substitution.isYellowCard = true;
        }
    }

    getPlayerOutLabel() {
        if (!this.substitution.playerOut)
            return "-------";

        let player =  this.squadDictionary[this.substitution.playerOut];

        if (!player)
            return "-------";

        return this.getPlayerName(player);
    }

    getPlayerInLabel() {
        if (!this.substitution.playerIn)
        return "-------";

        let player =  this.reserveDictionary[this.substitution.playerIn];

        if (!player)
            return "-------";

        return this.getPlayerName(player);
    }

    getPlayerName(player: PlayerDto): string {
        let result = (player.name ? player.name[0] + ". " : "" )+ player.surname;

        return result.trim();
    }

    getPositionLabel(): string {
        if (!this.substitution.position) {
            return "та же";
        }

        return this.pitchPositions[this.substitution.position];
    }

    selectPosition(val: number) {
        if (val === 0) {
            this.substitution.position = null;
        } else {
            this.substitution.position = val;
        }
    }

    onSubmit() {
        if (this.isModelValid()) {
            this.activeModal.close(this.substitution);
        }
    }

    isModelValid(): boolean {
        if (!this.substitution.playerIn || !this.substitution.playerOut) {
            return false;
        }

        if (this.substitution.playerIn && !this.reserveDictionary[this.substitution.playerIn]) {
            return false;
        }

        if (this.substitution.playerOut && !this.squadDictionary[this.substitution.playerOut]) {
            return false;
        }

        if (!this.substitution.minute && !this.substitution.mark && !this.substitution.physic
                && !this.substitution.score) {
            return false;
        }

        return true;
    }

    onSelectInPlayer(ev) {
        ev.stopPropagation();

        const modalRef = this.modalService.open(PlayerModal);

        modalRef.componentInstance.substitutionPlayers= this.playerService.sortPlayersByPosition(this.reserve);
        //modalRef.componentInstance.selectedPlayer = this.substitution.playerIn;

        modalRef.result.then((result) => {
            if (result) {
                this.substitution.playerIn = result.id;
            }
        }, (reason)=> {});
    }

    onSelectOutPlayer(ev) {
        ev.stopPropagation();

        const modalRef = this.modalService.open(PlayerModal);

        modalRef.componentInstance.squadPlayers= this.playerService.sortTacticPlayersByPosition(this.currectTactic.squad, this.squad);
        //modalRef.componentInstance.selectedPlayer = this.substitution.playerIn;

        modalRef.result.then((result) => {
            if (result) {
                this.substitution.playerOut = result.id;
            }
        }, (reason)=> {});
    }

    private buildLookups() {
        this.minutesLookup = [];
        for (let i = 0; i < 24; i++) {
            this.minutesLookup.push(i * 5);
        }

        this.scoresLookup = [];
        for (let i = -5; i < 6; i++) {
            this.scoresLookup.push(i);
        }

        this.marksLookup = [];
        for (let i = 4.0; i < 10; i+=0.5) {
            this.marksLookup.push(i);
        }

        this.physicsLookup = [];
        for (let i = 50; i < 100; i+=5) {
            this.physicsLookup.push(i);
        }

        this.pitchPositions = [];
        this.pitchPositions[0] = "та же";
        this.pitchPositions[CONSTANTS.pitchPositions.gk] = CONSTANTS.pitchPositionNames.gk;
        this.pitchPositions[CONSTANTS.pitchPositions.sw] = CONSTANTS.pitchPositionNames.sw;
        this.pitchPositions[CONSTANTS.pitchPositions.ldf] = CONSTANTS.pitchPositionNames.ldf;
        this.pitchPositions[CONSTANTS.pitchPositions.cdf] = CONSTANTS.pitchPositionNames.cdf;
        this.pitchPositions[CONSTANTS.pitchPositions.rdf] = CONSTANTS.pitchPositionNames.rdf;
        this.pitchPositions[CONSTANTS.pitchPositions.ldm] = CONSTANTS.pitchPositionNames.ldm;
        this.pitchPositions[CONSTANTS.pitchPositions.cdm] = CONSTANTS.pitchPositionNames.cdm;
        this.pitchPositions[CONSTANTS.pitchPositions.rdm] = CONSTANTS.pitchPositionNames.rdm;
        this.pitchPositions[CONSTANTS.pitchPositions.lmf] = CONSTANTS.pitchPositionNames.lmf;
        this.pitchPositions[CONSTANTS.pitchPositions.cmf] = CONSTANTS.pitchPositionNames.cmf;
        this.pitchPositions[CONSTANTS.pitchPositions.rmf] = CONSTANTS.pitchPositionNames.rmf;
        this.pitchPositions[CONSTANTS.pitchPositions.lam] = CONSTANTS.pitchPositionNames.lam;
        this.pitchPositions[CONSTANTS.pitchPositions.cam] = CONSTANTS.pitchPositionNames.cam;
        this.pitchPositions[CONSTANTS.pitchPositions.ram] = CONSTANTS.pitchPositionNames.ram;
        this.pitchPositions[CONSTANTS.pitchPositions.lfw] = CONSTANTS.pitchPositionNames.lfw;
        this.pitchPositions[CONSTANTS.pitchPositions.cfw] = CONSTANTS.pitchPositionNames.cfw;
        this.pitchPositions[CONSTANTS.pitchPositions.rfw] = CONSTANTS.pitchPositionNames.rfw;

        this.pitchPositionsLookup = [];
        this.pitchPositionsLookup.push(0);
        this.pitchPositionsLookup.push(CONSTANTS.pitchPositions.gk);
        this.pitchPositionsLookup.push(CONSTANTS.pitchPositions.sw);
        this.pitchPositionsLookup.push(CONSTANTS.pitchPositions.ldf);
        this.pitchPositionsLookup.push(CONSTANTS.pitchPositions.cdf);
        this.pitchPositionsLookup.push(CONSTANTS.pitchPositions.rdf);
        this.pitchPositionsLookup.push(CONSTANTS.pitchPositions.ldm);
        this.pitchPositionsLookup.push(CONSTANTS.pitchPositions.cdm);
        this.pitchPositionsLookup.push(CONSTANTS.pitchPositions.rdm);
        this.pitchPositionsLookup.push(CONSTANTS.pitchPositions.lmf);
        this.pitchPositionsLookup.push(CONSTANTS.pitchPositions.cmf);
        this.pitchPositionsLookup.push(CONSTANTS.pitchPositions.rmf);
        this.pitchPositionsLookup.push(CONSTANTS.pitchPositions.lam);
        this.pitchPositionsLookup.push(CONSTANTS.pitchPositions.cam);
        this.pitchPositionsLookup.push(CONSTANTS.pitchPositions.ram);
        this.pitchPositionsLookup.push(CONSTANTS.pitchPositions.lfw);
        this.pitchPositionsLookup.push(CONSTANTS.pitchPositions.cfw);
        this.pitchPositionsLookup.push(CONSTANTS.pitchPositions.rfw);
    }

    private buildPlayerDictionaries() {
        this.squadDictionary = [];

        this.squad.forEach(item => {
            this.squadDictionary[item.id] = item;
        });

        this.reserveDictionary = [];

        this.reserve.forEach(item => {
            this.reserveDictionary[item.id] = item;
        });
    }
}